import Typography from '@mui/material/Typography';
import TextField from '@mui/material/TextField';
import { useState } from 'react';
import Button from '@mui/material/Button';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
import { useMutation } from '@apollo/client';
import { useSnackbar } from 'notistack';
import {
  START_EMAIL_VERIFY,
  OTP_EMAIL_VERIFY,
  RESEND_EMAIL_VERIFY,
} from '../../../helpers/graphql/emailVerify';
import isEmail from 'validator/lib/isEmail';
import isInt from 'validator/lib/isInt';

export default function VerifyEmail({ setEmailVerificationComplete }) {
  const [email, setEmail] = useState('');
  const [newsletter, setNewsletter] = useState(false);
  const [submitted, setSubmitted] = useState(false);
  const [otp, setOtp] = useState();

  const [startEmailVerify] = useMutation(START_EMAIL_VERIFY);
  const [otpEmailVerify] = useMutation(OTP_EMAIL_VERIFY);
  const [otpResend] = useMutation(RESEND_EMAIL_VERIFY);

  const { enqueueSnackbar } = useSnackbar();

  const startVerify = () => {
    if (!email)
      enqueueSnackbar(`Please enter your email address`, {
        variant: 'error',
      });
    else if (!isEmail(email))
      enqueueSnackbar(`Please enter a valid email address`, {
        variant: 'error',
      });
    else
      startEmailVerify({
        variables: { email, newsletter },
      })
        .then(({ data }) => {
          if (data && data.startEmailVerify && !data.startEmailVerify.success)
            enqueueSnackbar(
              (data &&
                data.startEmailVerify &&
                data.startEmailVerify.message) ||
                'Could not verify email. Please try again.',
              {
                variant: 'error',
              },
            );
          else setSubmitted(true);
        })
        .catch(err => {
          console.error(err);
          enqueueSnackbar(`Could not submit email: ${err}`, {
            variant: 'error',
          });
        });
  };

  const otpVerify = () => {
    if (!otp)
      enqueueSnackbar(`Please enter a code`, {
        variant: 'error',
      });
    else if (!isInt(otp))
      enqueueSnackbar(
        `Please enter a correct code: A code can only contain numbers`,
        {
          variant: 'error',
        },
      );
    else
      otpEmailVerify({
        variables: { otp: parseInt(otp) },
      })
        .then(({ data }) => {
          if (!data || !data.otpEmailVerify || !data.otpEmailVerify.success)
            enqueueSnackbar(
              `Could not verify your email: ${data.otpEmailVerify.message}`,
              {
                variant: 'error',
              },
            );
          else {
            enqueueSnackbar(`Your email has been verified!`, {
              variant: 'success',
            });
            setEmailVerificationComplete(true);
          }
        })
        .catch(err => {
          console.error(err);
          enqueueSnackbar(`Could not submit code: ${err}`, {
            variant: 'error',
          });
        });
  };

  const resendOtp = () => {
    otpResend()
      .then(() => {
        enqueueSnackbar(`Your code has ben resent`, {
          variant: 'success',
        });
      })
      .catch(err => {
        console.error(err);
        enqueueSnackbar(`Could resend code: ${err}`, {
          variant: 'error',
        });
      });
  };

  if (submitted) {
    return (
      <>
        <Typography variant="body1">
          Please enter the 5 digit code we&apos;ve sent to <b>{email}</b>
        </Typography>
        <div className="pt-3">
          <TextField
            value={otp}
            onChange={event => setOtp(event.target.value)}
            label="Confirmation code"
            variant="outlined"
            inputProps={{ maxLength: 5 }}
          />
        </div>
        <div className="pt-3">
          <Button variant="contained" color="primary" onClick={otpVerify}>
            Verify
          </Button>
        </div>
        <div className="text-center pt-3">
          Didn&apos;t receive the code?{' '}
          <button
            className="twbtn tw-text-primary-500 dark:tw-text-primary-300 hover:tw-underline"
            onClick={resendOtp}
          >
            Resend
          </button>
        </div>{' '}
        <div className="text-center pt-3">
          Wrong email?{' '}
          <button
            className="twbtn tw-text-primary-500 dark:tw-text-primary-300 hover:tw-underline"
            onClick={() => {
              setSubmitted(false);
              setEmail('');
            }}
          >
            Go back
          </button>
        </div>
      </>
    );
  }
  return (
    <>
      <TextField
        className="tw-w-full sm:tw-w-80"
        value={email}
        onChange={event => setEmail(event.target.value)}
        label="Your email address"
        variant="outlined"
        inputProps={{ maxLength: 90 }}
      />
      <div>
        <FormControlLabel
          control={
            <Checkbox
              color="primary"
              checked={newsletter}
              onChange={() => setNewsletter(!newsletter)}
            />
          }
          label={
            <Typography color="textPrimary" display="inline">
              Optional: Subscribe to our newsletter
            </Typography>
          }
        />
      </div>
      <div>
        <Button variant="contained" color="primary" onClick={startVerify}>
          Verify Email
        </Button>
      </div>
      <Typography variant="body2" className="pt-2">
        We will use your email to notify you about important events regarding
        your blog.
      </Typography>
    </>
  );
}
